module.exports = __webpack_public_path__ + "img/DisabledFeedbackGood.b0cc09d5.png";